const { createProductTiles } = require('../tiles/product-tile-factory');

class NewProductsTileListController {
    constructor(settings, newProductsService, sortByKeys) {
        this.settings = settings;
        this.newProductsService = newProductsService;
        this.sortByKeys = sortByKeys;
    }

    $onInit() {
        this.sortOptions = { sortTypes: this.settings.new.sortOptions, sortContext: this.sortByKeys.NEW_KEY };
    }

    createTiles(response) {
        return {
            items: createProductTiles(response.Items),
            totalRecordCount: response.TotalRecordCount,
        };
    }

    getTiles(pageSize, pageNumber, sortType) {
        return this.newProductsService.getProducts(pageSize, pageNumber, sortType)
            .then(response => this.createTiles(response));
    }
}

NewProductsTileListController.$inject = ['Settings', 'NewProductsService', 'SortByKeys'];

const newProductsTileListComponentDefinition = {
    bindings: {
        pageNumber: '<',
        sortBy: '<',
    },
    controller: NewProductsTileListController,
    template: `
        <wow-tile-list
            list-title="'New Products'"
            page-number="$ctrl.pageNumber"
            sort-by="$ctrl.sortBy"
            sort-options="::$ctrl.sortOptions"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">

            <zero-result>
                <div class="newProductsTileList-zeroResult">
                    <h1 class="newProductsZeroResult-title">No new products found</h1>
                    <p>Sorry, no new products were found. Please check back soon.</p>
                </div>
            </zero-result>
        </wow-tile-list>
    `,
};

module.exports = {
    NewProductsTileListController,
    newProductsTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/newproducts/newproducts-tile-list.component.js